import { Button, Icon } from "web/components"
import useDropDownMenu from "web/hooks/behaviour/useDropDownMenu"
import useAutoId from "web/hooks/behaviour/useAutoId"
import { AddConditionDropDown } from "../DropDowns"

export default function AddConditionButton({
  fields,
  handleAddFieldCondition,
  handleAddDistanceCondition,
  recommendedFilters,
  hasComparableFilters,
  hasDistanceFilterSelected,
}) {
  const id = useAutoId()
  const { DropDownMenu, menuVisible, toggleMenu } = useDropDownMenu({
    triggerElementId: id,
  })

  return (
    <>
      <Button
        onClick={toggleMenu}
        id={id}
        variant="tertiary_default"
        size="small"
        testId="button-filter-condition-add"
      >
        Add Filter
        <span className="ml-1">
          <Icon name="plus" />
        </span>
      </Button>
      {menuVisible && (
        <DropDownMenu>
          <AddConditionDropDown
            recommendedFilters={recommendedFilters}
            hasDistanceFilterSelected={hasDistanceFilterSelected}
            fields={fields}
            hasComparableFilters={hasComparableFilters}
            onCancel={toggleMenu}
            onAddFieldCondition={(field) => {
              handleAddFieldCondition(field)
              toggleMenu()
            }}
            onAddDistanceCondition={(object) => {
              handleAddDistanceCondition(object)
              toggleMenu()
            }}
          />
        </DropDownMenu>
      )}
    </>
  )
}
